import { formatSaleEndDate, useFormatDate } from '@wix/package-picker-shared';
import { SaleType } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../ModuleProvider';
import { eclipseServerData } from '../../utils';
const SEASONAL_SALE_TYPES = new Set([SaleType.SEASONAL_SALE, SaleType.SEASONAL_EXTENDED, SaleType.SPECIAL_DISCOUNT]);
export const SaleDisclaimer = () => {
  var _data$discount$discou;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    locale,
    geo
  } = eclipseServerData.get();
  const formatDate = useFormatDate({
    locale
  });
  const {
    data
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  if (!(data != null && data.hasSale)) {
    return null;
  }
  const saleType = (_data$discount$discou = data.discount.discountInfo.sale) == null ? void 0 : _data$discount$discou.saleType;
  const expiresAt = data.discount.expiresAt;
  if (SEASONAL_SALE_TYPES.has(saleType) && expiresAt) {
    return t('sale.footer.offer', {
      date: formatSaleEndDate({
        saleEndDate: new Date(expiresAt).getTime(),
        geo,
        formatter: formatDate
      })
    });
  }
  if (saleType === SaleType.PERSONAL_SALE) {
    return t('sale.footer.personal_sale_offer');
  }
  return null;
};
//# sourceMappingURL=SaleDisclaimer.js.map